import { useParams, Link } from "react-router-dom";
import { byCategory, getCategory } from "@/lib/site";
import { ArticleCard } from "@/components/ArticleCard";
import { AdSlot } from "@/components/AdSlot";
import { Newsletter } from "@/components/Newsletter";
import { useSEO } from "@/lib/useSEO";

export default function Category() {
  const { slug } = useParams();
  const cat = getCategory(slug);
  const list = byCategory(slug);

  useSEO({
    title: cat ? `${cat.name} — Viajes low cost | Ruta Inteligente` : "Categoría",
    description: cat?.desc,
  });

  if (!cat) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-24 text-center">
        <h1 className="font-heading text-4xl font-semibold">Categoría no encontrada</h1>
        <Link to="/" className="text-brand-terra mt-4 inline-block">Volver al inicio</Link>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
      <nav className="text-sm text-brand-sub mb-6">
        <Link to="/" className="hover:text-brand-terra">Inicio</Link> <span className="mx-1">/</span>{" "}
        <span className="text-brand-ink">{cat.name}</span>
      </nav>
      <header className="mb-10 max-w-2xl">
        <p className="text-xs uppercase tracking-[0.2em] text-brand-terra mb-3">Categoría</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-brand-ink">{cat.name}</h1>
        <p className="text-brand-sub mt-3 text-lg">{cat.desc}</p>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
        {list.map((a, i) => (
          <ArticleCard key={a.slug} article={a} index={i} />
        ))}
      </div>

      <AdSlot />
      <Newsletter />
    </div>
  );
}
